import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TbDownload, TbMenu2, TbX } from 'react-icons/tb';
import '../i18n';
import { CV_PATH } from '../data/profile';
import './assets/css/navbar.css';

const links = [
  { href: '#home', key: 'nav_about' },
  { href: '#skills', key: 'nav_skills' },
  { href: '#experience', key: 'nav_experience' },
  { href: '#education', key: 'nav_education' },
  { href: '#contact', key: 'nav_contact' },
];

function Navbar() {
  const { t, i18n } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [active, setActive] = useState('#home');

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 10);
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Resalta el link de la sección visible
  useEffect(() => {
    const sections = links
      .map((l) => document.querySelector(l.href))
      .filter(Boolean);
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(`#${entry.target.id}`);
        });
      },
      { rootMargin: '-45% 0px -50% 0px' }
    );
    sections.forEach((s) => observer.observe(s));
    return () => observer.disconnect();
  }, []);

  const closeMenu = () => setIsMenuOpen(false);
  const lang = i18n.language === 'es' ? 'es' : 'en';

  return (
    <header className={`site-nav ${isScrolled || isMenuOpen ? 'scrolled' : ''}`}>
      <nav className="site-nav-inner" aria-label="Main">
        <a href="#home" className="brand" onClick={closeMenu}>
          <span className="brand-mark">TB</span>
          <span className="brand-name">Tomás Bastiani</span>
        </a>

        <button
          className="nav-toggle"
          aria-label="Menu"
          aria-expanded={isMenuOpen}
          onClick={() => setIsMenuOpen((o) => !o)}
        >
          {isMenuOpen ? <TbX /> : <TbMenu2 />}
        </button>

        <div className={`nav-panel ${isMenuOpen ? 'open' : ''}`}>
          <ul className="nav-links">
            {links.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  className={active === l.href ? 'active' : ''}
                  onClick={closeMenu}
                >
                  {t(l.key)}
                </a>
              </li>
            ))}
          </ul>

          <div className="nav-actions">
            <div className="lang-switch" role="group" aria-label={t('language')}>
              {['en', 'es'].map((code) => (
                <button
                  key={code}
                  className={lang === code ? 'active' : ''}
                  aria-pressed={lang === code}
                  onClick={() => {
                    i18n.changeLanguage(code);
                    closeMenu();
                  }}
                >
                  {code.toUpperCase()}
                </button>
              ))}
            </div>
            <a
              href={CV_PATH}
              download="CV_Tomas_Bastiani.pdf"
              className="btn-primary-grad nav-cv"
              onClick={closeMenu}
            >
              <TbDownload /> {t('downloadCV')}
            </a>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Navbar;
